exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:991px){.alert[data-v-2fe2071a]{width:auto!important;margin:0 10px}.alert.left[data-v-2fe2071a]{left:0!important}.alert.right[data-v-2fe2071a]{right:0!important}.alert.center[data-v-2fe2071a]{margin:0 10px!important}}.alert[data-v-2fe2071a]{z-index:100;cursor:pointer;position:fixed;width:41%}.alert.center[data-v-2fe2071a]{left:0;right:0;margin:0 auto}.alert.center[data-v-2fe2071a],.alert.left[data-v-2fe2071a],.alert.right[data-v-2fe2071a]{margin-top:10px}.alert.left[data-v-2fe2071a]{left:20px}.alert.right[data-v-2fe2071a]{right:20px}", ""]);

// exports
